import React from 'react';
import _ from "underscore";

// Loops, loops, loops

const Loops  = function(props){
    const childBlocks = _.values(props.blocks).map((Block, id) => <Block.component context={props.context} key={id}/>);

    if (childBlocks.length > 0) {
        return (
            <category name='Loops' id='loops' iconclass='category with-icon-paths snap-icon-loop_dual'>
                <label text="Loops"></label>
                { childBlocks }
            </category>
        );
    }
    
    return null;
}

export default Loops;